import React from "react";
import { CaptacaoInicio } from "./components/Inicio";
import { CaptacaoProvider } from "./context/CaptacaoContext";

export const Captacao = () => {
  return (
    <CaptacaoProvider>
      <CaptacaoInicio />
    </CaptacaoProvider>
  );
};
